import styled from 'styled-components';

export const MultiEmailInputStyle = styled.div`
  min-height: 46px;
  padding: 4px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background-color: #1a1a1a;
  cursor: text;
  transition: all 0.3s;

  &:hover:not(.disabled) {
    border-color: #40a9ff;
  }

  &.focused {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &.disabled {
    background-color: #141414;
    cursor: not-allowed;
    opacity: 0.6;
  }

  .email-tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }

  .email-tag {
    margin: 0;
    padding: 4px 8px;
    background-color: #007aff;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: lowercase !important;

    .anticon-close {
      font-size: 12px;
      cursor: pointer;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .email-input {
    flex: 1;
    min-width: 150px;
    height: 36px;
    border: none;
    outline: none;
    background: transparent;
    color: #ffffff;
    font-size: 14px;
    padding: 0 4px;

    &::placeholder {
      color: #888888;
    }

    &:disabled {
      cursor: not-allowed;
    }
  }
`;

